<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible="true"
    :before-close="handleClose"
    :title="$t('CampaignsList_WorkflowMigrationDialog_Title')"
    width="600px"
    center
  >
    <el-row type="flex" flex-direction="column" justify="center">
      <p>
        {{ $t('CampaignsList_WorkflowMigrationDialog_Description') }}
      </p>
      <p style="font-weight: 900;">
        {{ $t('CampaignsList_WorkflowMigrationDialog_Warning') }}
      </p>
      <p v-if="disabled" style="color: rgb(255,0,0);">
        {{ $t('CampaignsList_WorfklowMigrationDialog_RunningWarning') }}
      </p>
      <el-button
        type="primary"
        :loading="migrationLoading"
        @click="startMigration"
        :disabled="disabled"
      >
        {{ $t('CampaignsList_WorfklowMigrationDialog_StartMigration') }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { EventBus } from '@/core/EventBus'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { campaignStatus } from '@/modules/campaign-manage/enum/CampaignStatusEnum'

export default {
  name: 'WorkflowMigrationDialog',

  props: {
    migrationCampaign: Object
  },

  data() {
    return {
      migrationLoading: false
    }
  },

  computed: {
    disabled() {
      return (
        this.migrationCampaign.status === campaignStatus.RUNNING ||
        this.migrationCampaign.status === campaignStatus.CLOSED
      )
    }
  },

  methods: {
    startMigration() {
      this.migrationLoading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `campaigns/migrate-workflow`,
          data: {
            campaign_id: this.migrationCampaign.id
          }
        })
      )
        .then(({ data }) => {
          this.migrationLoading = false
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data.id }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.migrationLoading = false
        })
    },

    handleClose() {
      EventBus.$emit('workflowMigrationDialog', null)
    }
  }
}
</script>

<style scoped lang="scss">
.el-row {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-left: 50px;
  padding-right: 50px;
  word-break: keep-all;
}

p {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/WorkflowMigrationDialog.vue